import { WritableDraft } from 'immer/dist/types/types-external';

import { RowData, Snippet, SnippetType, UUID } from '../services/dataModels';

export const updateRowStatus = <T extends RowData>(
  snippet: WritableDraft<Snippet>,
  type: SnippetType,
  id: { key: string; value: UUID },
  status: { key: string; value: T },
) => {
  // TODO: use rollupIndex instead
  if (snippet.type === type)
    snippet.data[0].rowData.forEach((r) => {
      if (r[id.key] === id.value) {
        r[status.key] = status.value;
      }
    });
};
